module.exports = __webpack_public_path__ + "static/img/gpt54.6d4c2a21.png";